import React from 'react';
import Loader from "../Loader";

// This is deprecated and should be removed in the future
function Progress(props) {
    return <Loader {...props}/>
}

export default Progress;
